module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/7-af9c5021bdbee8caaaa258f4cb00716e.jpg";